import React, { useState, useEffect } from 'react';
import {
  mobileAppDemo,
  computerBlast,
  phoneGIF,
  uptrendArrow
} from "./images";

import LoginModal from '../oauth/LoginModal';
import Header from "../LandingPage/Header";
import LogoCarousel from './LogoCarousel';
import { FooterComponents } from './FooterComponents';

export default function LandingPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  // Handle mobile menu scroll lock
  useEffect(() => {
    // Add the "no-scroll" class when the mobile menu is open
    if (isMobileMenuOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup when the component unmounts or when isMobileMenuOpen changes
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isMobileMenuOpen]);

  // Add smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
    return () => {
      document.documentElement.style.scrollBehavior = "auto";
    };
  }, []);

  return (
    <div className="inter-custom overflow-hidden md:overflow-visible max-w-full flex flex-col min-h-screen bg-white">
      <Header setIsLoginOpen={setIsLoginOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} isMobileMenuOpen={isMobileMenuOpen} />

      <main>
        {/* Hero Section */}
        <section className="min-h-[600px] bg-[#FFFFFF] text-[#2b0062]">
          <div className="container mx-auto px-4 grid md:grid-cols-2 gap-8 items-center pt-4 pb-12">
            <div className="text-center md:justify-center">
              <h1 className="text-5xl md:text-[clamp(2.5rem,5vw,6rem)] font-bold mb-6 leading-tight">
                Instant&nbsp;Texts
                <br />
                Instant&nbsp;Crowds
              </h1>
              <p className="text-4xl md:text-[clamp(1.5rem,3vw,2.5rem)] mb-8 text-[#555555] inter-custom">
                Text&nbsp;your&nbsp;customers
                <br />
                to&nbsp;drive&nbsp;foot&nbsp;traffic
              </p>
              <a href="https://calendar.app.google/64qw1CsuCwEXYG1v9" target="_blank" rel="noopener noreferrer">
                <button className="bg-[#2b0062] text-[#FFFFFF] px-20 py-5 rounded-full text-3xl font-bold hover:bg-opacity-90 transition-colors">
                  Try It
                </button>
              </a>
              <p className="mt-8 text-2xl italic text-[#a6a6a6]">
                Created by service industry professionals for the service industry.
              </p>
            </div>
            <div className="relative h-[600px] flex items-center">
              {/* Phone */}
              <div className="relative w-full h-full flex items-center justify-center lg:justify-start xl:justify-center">
                <img
                  src={phoneGIF}
                  alt="Mobile messaging interface"
                  className="object-contain h-full z-10 lg:scale-90 xl:scale-95 lg:-ml-8 xl:ml-0"
                />

                {/* 200+ Drinks Sold */}
                <div className="hidden lg:flex flex-col items-start z-10 lg:ml-4 xl:ml-8 self-start pt-[25%]">
                  <div className="flex items-center">
                    <span className="text-2xl lg:text-3xl xl:text-4xl text-black">200 +</span>
                    <div className="ml-2 flex items-center">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 19V5M12 5L5 12M12 5L19 12"
                          stroke="#22c55e"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-[#555555] ml-1">30%</span>
                    </div>
                  </div>
                  <div className="text-xl lg:text-xl xl:text-2xl italic font-medium text-[#555555]">Drinks Sold</div>
                </div>
              </div>

              <div className="absolute hidden lg:block z-0 bottom-0 right-0 w-40 lg:w-48 xl:w-54 2xl:w-60 h-auto overflow-visible pointer-events-none transform -translate-y-3/4 lg:-translate-x-14 xl:-translate-x-24">
                <img
                  src={uptrendArrow}
                  alt="Upward trending arrow"
                  className="object-contain w-full h-full"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Fill Your Bar Section */}
        <section className="min-h-[600px] py-12">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-6xl md:text-6xl font-bold mb-6 text-[#2b0062]">Fill your Bar with One Text</h2>
            <p className="text-4xl text-[#555555] max-w-2xl mx-auto mb-8">
              Quick promos, packed nights.
              <br />
              Keep your crowd coming back.
            </p>
            <div className="relative h-[400px] mt-8">
              <img
                src={computerBlast}
                alt="LastCall Dashboard"
                className="object-contain w-full h-full"
              />
            </div>
          </div>
        </section>

        {/* Reach Customers Section */}
        <section className="min-h-[600px] bg-white text-[#2b0062] py-12">
          <div className="container mx-auto px-4 text-center max-w-3xl">
            <h2 className="text-6xl md:text-6xl font-bold mb-8">Actually Reach Customers</h2>
            <p className="text-2xl text-[#555555] mb-6">
              Only 4% of your customers
              <br />
              following your account sees
              <br />
              your social media posts.
            </p>
            <p className="text-2xl font-bold mb-8">
              Text messaging has an open
              <br />
              rate of 98%.
            </p>
            <p className="text-2xl text-[#555555] mb-8">
              With LastCall, text your
              <br />
              customers so they <span className="font-bold text-[#2b0062]">know</span> what
              <br />
              your business has to offer.
            </p>
            <a href="https://calendar.app.google/64qw1CsuCwEXYG1v9" target="_blank" rel="noopener noreferrer">
              <button className="bg-[#2b0062] text-white px-20 py-5 rounded-full text-3xl font-bold hover:bg-opacity-90 transition-colors">
                Try It
              </button>
            </a>
          </div>
        </section>

        {/* Logos Section */}
        <section className="min-h-[300px] py-6 mt-10 mb-0">
          <div className="container mx-auto px-4 text-center max-w-3xl">
            <p className="text-5xl text-[#2b0062] font-bold mb-8">
              Bars Boosting Business with <br></br> Last Call
            </p>
          </div>
          <LogoCarousel></LogoCarousel>
        </section>

        {/* Features Section */}
        <section className="min-h-[600px] py-6">
          <div className="container mx-auto px-0 md:px-4 lg:px-16 xl:px-32 grid md:grid-cols-2 gap-8 items-center">
            <div className="relative h-[600px]">
              <img
                src={mobileAppDemo}
                alt="Mobile messaging interface"
                className="object-contain w-full h-full"
              />
            </div>
            <div className="space-y-6 ">
              <div className="w-full flex md:flex-row bg-[#2b0062] bg-opacity-15 p-6 md:rounded-xl items-center space-x-6 text-center md:text-center">
                <h3 className="md:text-3xl text-4xl font-bold text-[#2b0062]">
                  Real-Time
                  < br />
                  &
                  < br />
                  Scheduled
                </h3>
                <p className="md:text-xl text-2xl text-[#2e2e2e]">
                  Notify customers instantly about deals and events or schedule texts ahead of time.
                </p>
              </div>
              <div className="flex md:flex-row bg-[#2b0062] bg-opacity-15 p-6 md:rounded-xl items-center space-x-6 text-center md:text-center">
                <h3 className="md:text-3xl text-4xl font-bold text-[#2b0062] mb-2">
                  Effortless
                  < br />
                  Set Up &
                  < br />
                  Use
                </h3>
                <p className="md:text-xl text-2xl text-[#2e2e2e]">Reaching your customers is now faster than making a martini.</p>
              </div>
              <div className="flex md:flex-row bg-[#2b0062] bg-opacity-15 p-6 md:rounded-xl items-center space-x-6 text-center md:text-center">
                <h3 className="md:text-3xl text-4xl font-bold text-[#2b0062] mb-2">
                  Know&nbsp;Your
                  < br />
                  Customers
                </h3>
                <p className="md:text-xl text-2xl text-[#2e2e2e]">
                  View customer demographics and target messages to certain crowd.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Mobile Footer */}
      <div className="md:hidden">
        <FooterComponents isMobile={true} setIsLoginOpen={setIsLoginOpen} />
      </div>

      {/* Desktop Footer */}
      <div className="hidden md:block">
        <FooterComponents isMobile={false} setIsLoginOpen={setIsLoginOpen} />
      </div>

      <LoginModal open={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </div>
  );
}